/**
 * Navigation prevention utility for file operations
 * Prevents users from accidentally navigating away during uploads/downloads
 */

let beforeUnloadHandler = null;
let isNavigationBlocked = false;

/**
 * Enable navigation prevention
 * @param {string} message - Custom message to show (optional, browser may ignore)
 */
export function enableNavigationPrevention(message = 'You have file operations in progress. Are you sure you want to leave?') {
    if (isNavigationBlocked) {
        console.log('[Navigation Prevention] Already enabled, skipping');
        return; // Already enabled
    }
    
    beforeUnloadHandler = (event) => {
        event.preventDefault();
        event.returnValue = message;
        return message;
    };
    
    window.addEventListener('beforeunload', beforeUnloadHandler);
    isNavigationBlocked = true;
    
    console.log('[Navigation Prevention] Enabled');
}

/**
 * Disable navigation prevention
 */
export function disableNavigationPrevention() {
    if (!isNavigationBlocked) {
        console.log('[Navigation Prevention] Already disabled, skipping');
        return; // Already disabled
    }
    
    if (beforeUnloadHandler) {
        window.removeEventListener('beforeunload', beforeUnloadHandler);
        beforeUnloadHandler = null;
    }
    
    isNavigationBlocked = false;
    console.log('[Navigation Prevention] Disabled');
}

/**
 * Check if navigation prevention is currently active
 * @returns {boolean}
 */
export function isNavigationPreventionActive() {
    return isNavigationBlocked;
}

/**
 * Create a Vue Router navigation guard that prevents navigation during file operations
 * @param {Function} isFileOperationInProgress - Function that returns true if file operations are in progress
 * @returns {Function} Navigation guard function
 */
export function createNavigationGuard(isFileOperationInProgress) {
    return (to, from, next) => {
        if (isFileOperationInProgress()) {
            const confirmed = window.confirm(
                'You have file operations in progress. Are you sure you want to leave? This may cancel your upload or download.'
            );
            
            if (confirmed) {
                console.log('[Navigation Prevention] User confirmed navigation away from file operation');
                next();
            } else {
                console.log('[Navigation Prevention] User cancelled navigation');
                next(false);
            }
        } else {
            next();
        }
    };
} 